var map = {
	"./404.svg": 8790,
	"./BarCode.svg": 4914,
	"./active_Pledge.svg": 6672,
	"./active_dashboard.svg": 4953,
	"./active_e_commerce.svg": 3014,
	"./active_filter_icon.svg": 5235,
	"./active_logout.svg": 2521,
	"./active_notification.svg": 5890,
	"./active_settings.svg": 6504,
	"./active_ticket_icon.svg": 7385,
	"./active_transaction.svg": 5425,
	"./approval_danger_icon.svg": 1617,
	"./article_icon.svg": 3820,
	"./back_button.svg": 9410,
	"./bottomCorner.svg": 9584,
	"./branch_icon.svg": 5694,
	"./calendar_icon.svg": 1064,
	"./danger_icon.svg": 6689,
	"./dashboard_1st_card.svg": 848,
	"./dashboard_2nd_card.svg": 5688,
	"./dashboard_3rd_card.svg": 5879,
	"./dashboard_4th_card.svg": 9056,
	"./dashboard_active.svg": 8519,
	"./dashboard_hover.svg": 9873,
	"./dashboard_inactive.svg": 7766,
	"./deactive_e_commerce.svg": 357,
	"./deactive_home.svg": 3393,
	"./deactive_logout.svg": 8934,
	"./deactive_notification.svg": 521,
	"./deactive_pledge.svg": 9404,
	"./deactive_settings.svg": 4291,
	"./deactive_transaction.svg": 3292,
	"./default_filter_icon.svg": 9814,
	"./doit_now_logo.svg": 1715,
	"./down_arrow.svg": 5776,
	"./downloan_icon.svg": 6416,
	"./due_icon.svg": 7764,
	"./duit_now_logo_icon.svg": 5959,
	"./edit_icon_button.svg": 9649,
	"./email_first_login.svg": 9387,
	"./email_not_found.svg": 7765,
	"./error_icon.svg": 5296,
	"./finger_scan.svg": 1355,
	"./hover_e_commerce.svg": 9406,
	"./hover_home.svg": 5682,
	"./hover_logout.svg": 5937,
	"./hover_notification.svg": 4762,
	"./hover_pledge.svg": 152,
	"./hover_settings.svg": 3840,
	"./hover_transaction.svg": 5401,
	"./instalment.svg": 2589,
	"./login-right-arrow.svg": 5428,
	"./logo.svg": 3643,
	"./notification_icon.svg": 8217,
	"./offer_banner.svg": 5677,
	"./password-key.svg": 4827,
	"./pawn_ticket.svg": 4755,
	"./payable.svg": 9376,
	"./profile_avatar.svg": 199,
	"./profile_icon.svg": 5439,
	"./red_info_icon.svg": 1134,
	"./reload.svg": 7185,
	"./right_outline_arrow.svg": 6501,
	"./singpass_logo.svg": 354,
	"./singpass_logo_gray.svg": 4035,
	"./singpass_logo_white.svg": 2660,
	"./success_icon.svg": 8365,
	"./ticket_icon.svg": 3962,
	"./topCorner404.svg": 2596,
	"./top_arrow.svg": 8125,
	"./up_arrow.svg": 7471,
	"./user-icon.svg": 5583,
	"./warning_icon_branch.svg": 993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7729;